import { useEffect, useState } from "react";
import { formatPrice, ordersAvailable, whatsappNumber } from "../../menu.js";
import { checkDeliveryCost, deliveryCostOf } from "../../businessValidation.js";

const COST_MODES = [
    ["confirmar", "A confirmar"],
    ["gratis", "Gratis"],
    ["fijo", "Precio fijo"]
];

const modeOf = (cost) => cost === null ? "confirmar" : cost === 0 ? "gratis" : "fijo";
const costText = (cost) => cost ? String(cost).replace(".", ",") : "";

// Cuánto cuesta el envío a domicilio: lo ve el cliente al elegir "Envío a domicilio" en el carrito.
const DeliveryCost = ({ business, onSave }) => {

    const saved = deliveryCostOf(business);
    const [mode, setMode] = useState(modeOf(saved));
    const [amount, setAmount] = useState(costText(saved));
    const [touched, setTouched] = useState(false);
    const [saving, setSaving] = useState(false);

    useEffect(() => {
        setMode(modeOf(saved));
        setAmount(costText(saved));
    }, [saved]);

    const check = checkDeliveryCost(amount);
    const problem = mode === "fijo" && touched ? check.error : null;
    const changed = mode === "fijo" && !check.error && check.value !== saved;

    const save = async (value) => {
        setSaving(true);
        await onSave(value);
        setSaving(false);
    }

    const pick = (next) => {
        setMode(next);
        setTouched(false);
        if (next === "confirmar" && saved !== null) save(null);
        if (next === "gratis" && saved !== 0) save(0);
        if (next === "fijo" && !saved) setAmount("");
    }

    const submit = (e) => {
        e.preventDefault();
        setTouched(true);
        if (!check.error) save(check.value);
    }

    const hint = mode === "confirmar" ? "En el carrito avisamos que el total no incluye el envío y que se lo confirmás por WhatsApp." :
        mode === "gratis" ? "En el carrito el envío figura gratis." :
        saved ? `Si el cliente elige envío a domicilio, el carrito suma ${formatPrice(saved)} al total.` :
        "Si el cliente elige envío a domicilio, el carrito lo suma al total.";

  return (
    <div className="lp-panel-delivery">
        <span className="lp-panel-label" id="costo-envio">Costo del envío a domicilio</span>
        <div className="lp-panel-chips lp-panel-delivery-modes" role="radiogroup" aria-labelledby="costo-envio">
            {COST_MODES.map(([id, label]) => (
                <button key={id} type="button" role="radio" aria-checked={mode === id} disabled={saving}
                    className={mode === id ? "lp-panel-chip lp-panel-chip-on" : "lp-panel-chip"} onClick={() => pick(id)}>{label}</button>
            ))}
        </div>

        {mode === "fijo" &&
            <form className="lp-panel-delivery-form" onSubmit={submit} noValidate>
                <label htmlFor="costo-envio-monto" className="lp-panel-sr">Costo del envío en pesos</label>
                <div className="lp-panel-money">
                    <span aria-hidden="true">$</span>
                    <input id="costo-envio-monto" type="text" inputMode="decimal" autoComplete="off" placeholder="1500" maxLength={12} value={amount}
                        onChange={(e) => setAmount(e.target.value.replace(/[^0-9.,$ ]/g, ""))} onBlur={() => amount && setTouched(true)}
                        aria-invalid={!!problem} aria-describedby="costo-envio-msg"/>
                </div>
                <button type="submit" className="lp-btn lp-btn-primary lp-panel-btn-sm" disabled={saving || (!changed && !check.error)}>{saving ? "Guardando…" : "Guardar"}</button>
            </form>
        }
        <p id="costo-envio-msg" className={problem ? "lp-panel-delivery-msg is-err" : "lp-panel-delivery-msg"}>{problem || hint}</p>
    </div>
  )
}

// Interruptor del carrito del menú: los clientes arman el pedido y lo mandan al WhatsApp del negocio.
const OrdersCard = ({ business, onChange, onDeliveryCost, onEditData }) => {

    const [saving, setSaving] = useState(false);
    const available = ordersAvailable(business);
    const hasPhone = !!whatsappNumber(business.telefono);
    const on = business.pedidos === true && available;

    const toggle = async () => {
        setSaving(true);
        await onChange(!on);
        setSaving(false);
    }

  return (
    <section className="lp-panel-card lp-panel-stack">
        <div className="lp-panel-card-head">
            <h2>Pedidos por WhatsApp</h2>
            {!available && <span className="lp-panel-badge">Pro</span>}
        </div>
        <p className="lp-panel-muted">Tus clientes arman el pedido desde el menú y te llega escrito a tu WhatsApp, con cantidades y total.</p>

        {available ?
            <button type="button" className="lp-panel-switch lp-panel-switch-plain" role="switch" aria-checked={on} disabled={saving || (!on && !hasPhone)} onClick={toggle}>
                <span className="lp-panel-switch-track"><span className="lp-panel-switch-knob"></span></span>
                <span className="lp-panel-switch-text">{on ? "Activado" : "Desactivado"}</span>
            </button> :
            <a className="lp-text-link lp-panel-left" href="#cuenta">Pasate a Pro para recibir pedidos</a>
        }

        {available && !hasPhone &&
            <p className="lp-panel-notice">Para recibir pedidos cargá el WhatsApp del negocio. <button type="button" className="lp-text-link" onClick={onEditData}>Completar datos</button></p>
        }

        {on && onDeliveryCost && <DeliveryCost business={business} onSave={onDeliveryCost}></DeliveryCost>}
    </section>
  )
}

export default OrdersCard
